<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Affiliate performance PlanWise</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'AffiliatePerformance' }">Affiliate performance report</router-link>
              </li>
              <li class="breadcrumb-item active">
                Plan wise
              </li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <div class="btn-toolbar pull-right">
              <button class="btn btn-info" @click="show_filter = !show_filter" disabled>
                <i class="fa fa-filter"></i>Filter
              </button>
            </div>

            <div class="card-tools">
              <button class="btn btn-info" @click="exportReport()">
                <i class="fas fa-download"></i> Export
              </button>
            </div>
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="show_filter">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="username"
                    >Username</label
                    >
                    <div class="col-md-9">
                      <input
                        type="text"
                        id="username"
                        class="form-control"
                        v-model="filter.username"
                        placeholder="Username"
                      />
                    </div>
                  </div>
                </div>
                <!--<div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="created_at"
                    >Date range</label
                    >
                    <div class="col-md-9">
                      <date-picker
                        type="datetime"
                        input-class="form-control"
                        v-model="filter.created_at"
                        range
                        lang="en"
                        format="YYYY-MM-DD hh:mm:ss"
                        confirm
                        id="created_at"
                        value-type="YYYY-MM-DD hh:mm:ss"
                      ></date-picker>
                    </div>
                  </div>
                </div>-->
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9 offset-md-3">
                      <button type="submit" class="btn btn-common m-2px">
                        Search
                      </button>
                      <button
                        type="reset"
                        class="btn btn-warning"
                        @click="resetFilter()"
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <div class="card-body table-responsive-md p-0">
            <table class="table">
              <thead>
              <tr>
<!--                <th style="width: 10px">ID</th>-->
                <th>Referrer name </th>
                <th>Plan name</th>
                <th>No. of clicks</th>
                <th>Sales amount(Tk)</th>
                <th>Earned points </th>
                <th>Last sale at</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(student, index) in students">
<!--                <td>{{ student.id }}</td>-->
                <td>{{ student.referrer_name }} ({{ student.referrer_username }})</td>
                <td>{{ student.plan_name }}</td>
                <td>{{ student.total_click_count }}</td>
                <td>{{ student.total_order_price | afterDecimal2 }}</td>
                <td>{{ student.total_earned_points | afterDecimal2 }}</td>
                <td>{{ student.last_purchased_at | moment }}</td>
              </tr>
              </tbody>
            </table>

            <div class="p-4" v-if="_.isEmpty(students)">
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>
          <div class="card-footer">
            <vue-pagination
              :pagination="students"
              v-if="students.total > students.per_page"
              @paginate="init()"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent"
import {LearningReportApi} from "@/services/api"
import SortIcons from "@/components/utils/SortIcons"

import DatePicker from "vue2-datepicker"
import "vue2-datepicker/index.css"
import axios from "axios"
import fileDownload from "js-file-download"

export default {
  name: "AffiliatePerformancePlanWise",
  metaInfo: {
    title: "Aff. Performance | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons
  },
  data: () => ({
    students: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    show_filter: false,
    filter: {},
    is_loading: false,
  }),
  methods: {
    init() {
      this.filter = JSON.parse(JSON.stringify(this.$route.query))
      if (!_.isEmpty(this.filter)) this.show_filter = true
      this.is_loading = true
      let params = {...this.filter, ...this.$route.query, ...this.$route.params }
      LearningReportApi.affiliatePerformancePlanWise(params)
        .then((students) => {
          this.students = students
        })
        .finally(() => {
          this.is_loading = false
        })
    },
    resetFilter() {
      this.$router.push({path: this.$route.path}).catch(() => {
      })
    },
    async getFilterData() {
      this.$router
        .push({
          path: this.$route.fullPath,
          query: this.filter,
        })
        .catch((err) => {
          console.log(err)
        })
    },
    exportReport: function () {
      this.is_loading = true
      axios
        .get("/reports/affiliate/performance/plan-wise-export", {
          params: this.$route.params,
          responseType: "blob",
        })
        .then((response) => {
          fileDownload(response.data, "affiliate-plan-wise.xlsx")
        })
        .catch((error) => {
          console.log("error " + error)
        })
        .finally(() => {
          this.is_loading = false
        })
    },
  },
  mounted() {
    this.init()
    this.$root.$on('sort-data', () => {
      this.$root.$emit('show-icon')
    })
  },
  watch: {
    '$route.query'() {
      this.init()
    }
  },
  filters: {
    moment: function (date) {
      return (typeof date !== "undefined") ?
        moment(date).format("MMMM Do YYYY, h:mm:ss a") : '--'
    },
    afterDecimal2(data) {
      return (typeof data !== "undefined") ? parseFloat(data).toFixed(2) : 0
    }
  },
};
</script>
